import { PageHeaderMenuItem } from '@/components/PageHeader/PageHeader.model'
import { fetchAccessibleProductLink } from '@/utils/products/global-element-product-access-check'
import { processFourthLevelMenuItem } from '@/components/PageHeader/util/processFourthLevelMenuItem'
import { removeUSFromPath } from '@/components/PageHeader/util/UrlUtils'
import { renderProductDocumentPage } from '@/components/PageHeader/RenderProductDocumentPage'
import styles from '@/components/PageHeader/styles/mobileNavBar.module.scss'

export function renderThirdLevelMenuItem(
  thirdLevelMenuItem: PageHeaderMenuItem,
  thirdLevelItemIndex: number,
  allProductVersionsInfo: any,
  countryCode: string,
  isElavon: boolean,
  renderFourthLevelMenuItemWrapper: (
    value: PageHeaderMenuItem,
    index: number
  ) => JSX.Element | undefined
): JSX.Element | undefined {
  const PRODUCT_SUITE_PATH = 'product-suites'
  const superChild = thirdLevelMenuItem?.url?.split('/')
  const superChildPathDepth = superChild?.length ?? 0
  const superChildVersion = superChild ? superChild[superChild.length - 1] : ''
  const superChildProductSlug = superChild
    ? superChild[superChild.length - 2]
    : ''
  let superChildProductLink = thirdLevelMenuItem?.url

  if (!isElavon) {
    if (
      thirdLevelMenuItem.value &&
      superChildPathDepth - 1 > 2 &&
      superChildProductSlug !== PRODUCT_SUITE_PATH
    ) {
      if (
        allProductVersionsInfo['restrictedPrivateProductAllVersion']
          ?.productSlug &&
        allProductVersionsInfo['nonRestrictedPrivateProductAllVersion']
          ?.productSlug
      ) {
        superChildProductLink = fetchAccessibleProductLink(
          superChildVersion,
          superChildProductSlug,
          allProductVersionsInfo,
          countryCode
        )
      }
    }
  }

  let isProductSuiteProductAvailable: any = 0
  let isProductSuiteProductClassName = ''

  thirdLevelMenuItem?.menuItems?.items?.map(function (
    fourthLevelMenuItem: PageHeaderMenuItem
  ) {
    const { subChildProductLink, isProductSuiteProductAvailable } =
      processFourthLevelMenuItem(
        fourthLevelMenuItem,
        isElavon,
        allProductVersionsInfo,
        countryCode
      )
  })

  isProductSuiteProductClassName =
    superChildProductSlug !== PRODUCT_SUITE_PATH
      ? 'emptyProductsForProductSuite'
      : ''

  if (superChildProductLink) {
    superChildProductLink = removeUSFromPath(superChildProductLink)

    return (
      <li key={thirdLevelMenuItem.id}>
        <a
          className={styles.nested}
          href={`${superChildProductLink}` || '#'}
          data-testid={`thirdLevel-${thirdLevelMenuItem.id}`}
        >
          {thirdLevelMenuItem.value}
        </a>
        {/* Product Document Page */}
        {thirdLevelMenuItem?.childPages &&
          thirdLevelMenuItem.childPages.length > 0 && (
            <ul
              className={`${styles.childPages} ${
                styles.level3
              } ${superChildProductSlug} ${
                superChildProductSlug == 'product-suites'
                  ? isProductSuiteProductClassName
                  : ''
              }`}
            >
              {superChildProductLink != '/products' &&
                thirdLevelMenuItem?.childPages?.length > 0 && (
                  <li
                    className={styles.greatGrandSubMenu}
                    key={`productOverview-${thirdLevelItemIndex}`}
                  >
                    <a
                      id="mobile-product-overview-document"
                      data-testid="mobile-product-overview-document"
                      className={styles.nested}
                      href={`${superChildProductLink}` || '#'}
                    >
                      Product Overview
                    </a>
                  </li>
                )}
              {thirdLevelMenuItem?.childPages?.map(function (
                productDocumentPage: PageHeaderMenuItem,
                productDocumentPageIndex: number
              ) {
                return renderProductDocumentPage(
                  productDocumentPage,
                  productDocumentPageIndex
                )
              })}
            </ul>
          )}
        {/* Product Sub Menus */}
        {thirdLevelMenuItem?.hasSubMenus && (
          <ul className={`${styles.subMenu}  ${superChildProductSlug}`}>
            {thirdLevelMenuItem?.hasSubMenus &&
              thirdLevelMenuItem?.menuItems?.items?.map(
                renderFourthLevelMenuItemWrapper
              )}
          </ul>
        )}
      </li>
    )
  }
}
